import { render, staticRenderFns } from "./NaHradzi.vue?vue&type=template&id=1082c9ce&scoped=true"
import script from "./NaHradzi.vue?vue&type=script&lang=js"
export * from "./NaHradzi.vue?vue&type=script&lang=js"
import style0 from "./NaHradzi.vue?vue&type=style&index=0&id=1082c9ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1082c9ce",
  null
  
)

export default component.exports